import { ComboboxFiltersSAP, DisplayedColumns, SAPFilter } from '../model/local/sapfilters.model';

export enum TypeSAPFilter {
    numeric,
    string,
    date
}
export enum TypeReportsFilter {
    range = 'Range',
    contain = 'Contains',
    equals = 'Equals',
    default = ''
}
export const SAPFiltersNumeric: ComboboxFiltersSAP[] = [
    {
        description: 'Igual a',
        value: TypeReportsFilter.equals
    },
    {
        description: 'Rango',
        value: TypeReportsFilter.range
    }
];

export const SAPFiltersString: ComboboxFiltersSAP[] = [
    {
        description: 'Igual a',
        value: TypeReportsFilter.equals
    },
    {
        description: 'Contiene',
        value: TypeReportsFilter.contain
    }
];

export const SAPFiltersDate: ComboboxFiltersSAP[] = [
    {
        description: 'Igual a',
        value: TypeReportsFilter.equals
    },
    {
        description: 'Rango',
        value: TypeReportsFilter.range
    }
];

export const OpenOrdersFilterConfig: SAPFilter[] = [
    {
        filterName: 'transactionId',
        title: 'Transacción Shop',
        value: TypeSAPFilter.string,
        options: SAPFiltersString,
        displayedColumns: {
            initialValue: true,
            lastValue: false
        },
    },
    {
        filterName: 'status',
        title: 'Estatus pedido shop',
        value: TypeSAPFilter.string,
        options: [
            {
                description: 'Igual a',
                value: TypeReportsFilter.equals
            }
        ],
        displayedColumns: {
            initialValue: true,
            lastValue: false
        },
    },
    {
        filterName: 'cardCode',
        title: 'Cliente',
        value: TypeSAPFilter.string,
        options: [
            {
                description: 'Igual a',
                value: TypeReportsFilter.equals
            }
        ],
        displayedColumns: {
            initialValue: true,
            lastValue: false
        },
    },
    {
        filterName: 'createName',
        title: 'Nombre del cliente',
        value: TypeSAPFilter.string,
        options: [
            {
                description: 'Contiene',
                value: TypeReportsFilter.contain
            }
        ],
        displayedColumns: {
            initialValue: true,
            lastValue: false
        },
    },
];



export enum TypeSAPReport {
    clientWallet = 'ClientWallet',
    paymentAndBills = 'InvoicePayments',
    tradeCube = 'ComercialCube',
    openOrders = 'openOrders',
    default = ''
}

export enum TypeSAPReportKey {
    clientWallet = 'clientWallet',
    paymentBill = 'paymentBills',
    tradeCube = 'tradeCube',
    openOrders = 'openOrders'
}
export enum ValueTypesFilter {
    string = 'String',
    date = 'DateTime',
    decimal = 'Decimal'
}
